import clsx from "clsx";

export interface ContainerProps extends React.HTMLAttributes<HTMLDivElement> {}

export const containerPadding = {
  x: {
    default: 3,
    lg: 5,
  },
  t: {
    default: 4,
    lg: 8,
  },
};

export const containerPX =
  containerPadding.x.default === containerPadding.x.lg
    ? `px-${containerPadding.x.default}`
    : `px-${containerPadding.x.default} lg:px-${containerPadding.x.lg}`;

export const containerPT =
  containerPadding.t.default === containerPadding.t.lg
    ? `mt-${containerPadding.t.default}`
    : `mt-${containerPadding.t.default} lg:mt-${containerPadding.t.lg}`;

const Container = ({ className, ...props }: ContainerProps) => {
  const classes = clsx(containerPX, containerPT, className);

  return <div className={classes} {...props} />;
};

export default Container;
